import { LatestVoyageDataBM } from '../types/BusinessModel/LatestVoyageDataBM';
import { LatestVoyageData } from '../types/ViewModel/LatestVoyageData';

export default () => {
    const newLatestVoyageData = (latestVoyageData: LatestVoyageDataBM): LatestVoyageData => {
        return new LatestVoyageData(latestVoyageData.voyageNumber, latestVoyageData.voyageNumber1, latestVoyageData.voyageNumber2);
    };

    return {
        newLatestVoyageData,
    };
};
